(() => {
  'use strict';
  if (customElements.get('ps-team-spots')) return;
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  function state(row, stale = false) {
    const cap = Number(row.dataset.cap), stock = Number(row.dataset.stock), unit = row.dataset.title === 'Big Air' ? 'entry' : 'team';
    const known = row.dataset.known === 'true' && Number.isInteger(cap) && cap > 0 && /^-?\d+$/.test(row.dataset.stock || '') && Number.isInteger(stock) && stock <= cap;
    if (stale || !known) return { count: 'Check Availability', detail: cap > 0 ? `${cap} ${unit} cap` : '', low: false };
    const left = Math.max(0, stock);
    if (left === 0) return { count: 'Sold Out', detail: `${cap} ${unit} cap`, low: false };
    if (row.dataset.available !== 'true') return { count: 'Registration Unavailable', detail: `${cap} ${unit} cap`, low: false };
    return { count: String(left), detail: `of ${cap} ${unit} slots left`, low: left <= Math.ceil(cap * 0.2) };
  }
  class TeamSpots extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rows = [...this.querySelectorAll('[data-spot-row]')];
      this.status = this.querySelector('[data-spot-status]');
      this.button = this.querySelector('[data-spot-refresh]');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.button?.addEventListener('click', () => this.refresh(), { signal });
      this.onChange = () => { this.paint(); clearTimeout(this.changeTimer); this.changeTimer = setTimeout(() => this.paint(), 500); };
      if (this.dataset.mode === 'selected') document.addEventListener('change', this.onChange, { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, { signal });
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 60000);
      this.paint();
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer); clearTimeout(this.changeTimer); clearTimeout(this.timeout);
      this.controller?.abort(); this.request?.abort(); this.footer?.remove();
      this.ready = false;
    }
    selectedRow() {
      const product = this.closest('product-info');
      const checked = product?.querySelector('variant-selects input[type="radio"]:checked');
      const selected = product?.querySelector('variant-selects select');
      const title = checked?.value || selected?.value;
      if (title) return this.rows.find(row => row.dataset.title === title);
      const id = product?.querySelector('product-form form input[name="id"]')?.value;
      return this.rows.find(row => row.dataset.variant === id) || this.rows.find(row => !row.hidden);
    }
    paint() {
      this.dataset.stale = String(Boolean(this.stale));
      const picked = this.dataset.mode === 'selected' ? this.selectedRow() : null;
      for (const row of this.rows) {
        const current = state(row, this.stale);
        text(row.querySelector('[data-spot-count]'), current.count);
        text(row.querySelector('[data-spot-detail]'), current.detail);
        row.dataset.low = String(current.low);
        if (this.dataset.mode === 'selected') row.hidden = row !== picked;
      }
      if (this.dataset.mode === 'selected') {
        const submit = this.closest('product-info')?.querySelector('product-form button[type="submit"]');
        if (submit && !this.footer) {
          this.footer = document.createElement('p');
          this.footer.className = 'ps-spots-footer'; this.footer.setAttribute('role', 'status');
          submit.before(this.footer);
        }
        const current = picked ? state(picked, this.stale) : null;
        text(this.footer, current ? `${picked.dataset.title}: ${current.count}${/^\d+$/.test(current.count) ? ` ${current.detail}` : ` - ${current.detail}`}. Spots are secured after checkout.` : 'Choose your division above to check availability.');
      }
    }
    async refresh() {
      if (this.busy || !this.isConnected) return;
      this.busy = true; this.button.disabled = true;
      text(this.status, 'Checking latest availability...');
      this.request = new AbortController();
      this.timeout = setTimeout(() => this.request.abort(), 15000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('sections'); url.searchParams.delete('option_values');
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('_ps_spots', String(Date.now()));
        const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', signal: this.request.signal });
        if (!response.ok) throw new Error('Section unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const component = [...html.querySelectorAll('ps-team-spots')].find(node => node.dataset.key === this.dataset.key);
        const incoming = [...(component?.querySelectorAll('[data-spot-row]') || [])];
        if (!incoming.length || incoming.length !== this.rows.length) throw new Error('Incomplete inventory');
        const byId = new Map(incoming.map(row => [row.dataset.variant, row]));
        if (!this.rows.every(row => byId.has(row.dataset.variant))) throw new Error('Inventory mismatch');
        for (const row of this.rows) for (const key of ['stock', 'cap', 'known', 'available']) row.dataset[key] = byId.get(row.dataset.variant).dataset[key];
        this.stale = false; this.paint();
        const now = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        text(this.status, `Checked at ${now}. Refreshes every minute.`);
      } catch (error) {
        if (!this.isConnected) return;
        this.stale = true; this.paint();
        text(this.status, 'Could not refresh availability. Try Refresh Availability or check your division on the registration page.');
      } finally {
        clearTimeout(this.timeout); this.busy = false; this.button.disabled = false;
      }
    }
  }
  customElements.define('ps-team-spots', TeamSpots);
})();

